/**
 * Remove not required attributes from given object.
 *
 * @param {Object} obj
 * @param {Array} notRequiredAttributes
 */
export const withoutAttrs = (obj, notRequiredAttributes = []) => {
  return Object.keys(obj).reduce((result, key) => {
    if (!notRequiredAttributes.includes(key)) {
      result[key] = obj[key];
    }

    return result;
  }, {});
};

export const isEmptyObject = (obj) => {
  return Object.keys(obj).length === 0;
};

/**
 * Returns a new object with all string values trimmed of whitespace.
 *
 * @param {Object} obj - The object whose string values will be trimmed.
 * @returns {Object} A new object with trimmed string values.
 */
export const trimStringValuesInObject = (obj) => {
  if (!obj || typeof obj !== "object" || Array.isArray(obj)) return obj;

  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [
      key,
      typeof value === "string"
        ? value.trim()
        : trimStringValuesInObject(value),
    ])
  );
};
